<script lang="ts" setup>
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/free-mode'
import 'swiper/css/scrollbar'
import 'swiper/css/zoom'
import 'swiper/css/thumbs'
import { useGoodsStore } from '~/store/store-goods/goods'
import Dialog from '@/components/dialog/dialog-modal/dialog.vue'
import NliveCard from '~/pages/store/fixed/components/units/nlive-card.vue'

const goodsStore = useGoodsStore()
const { nLiveBroadCast } = storeToRefs(goodsStore)
</script>

<template>
  <div class="nlive-wrap">
    <h3 class="title">이 영상으로 상품 확인하기</h3>

    <div class="vod-list-wrap">
      <ul class="vod-list">
        <li class="item" v-for="(item, index) in nLiveBroadCast" :key="index">
          <NliveCard :item="item" />
        </li>
      </ul>
    </div>
  </div>
  <Dialog ref="dialogRef" />
</template>

<style lang="scss"></style>
